module.exports = __webpack_public_path__ + "static/img/goodsliststyle2.139a11b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/goodsliststyle2.png
// module id = s4wI
// module chunks = 174